import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Spinner from 'react-spinner-material';
import WorkOrderImages from './WorkOrderImages';
import { FaFilter, FaEdit } from 'react-icons/fa';
import Dialog from 'react-bootstrap-dialog';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import ReactTable from "react-table";
import "react-table/react-table.css";

import { Multiselect } from 'multiselect-react-dropdown';

import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR } from '../icon';
import { EVENT_NAME_CHANGE_WO_STATUS, WO_BONG, WO_HOANTHANH } from '../constants';
import UserDataService from '../services/UserDataService';

class KcsProductList extends Component {
  constructor() {
    super();

    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths * 30 * 24 * 60 * 60 * 1000 * 3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      show: false,
      spinnerVisible: false,
      allStatus: [],
      fromDate: fromDate,
      toDate: toDate,
      status: '0',
      orderNo: null,
      woStatus: 0,
      workOrders: [],
      childRefreshCount: 0,
      sku: '',
      selectedWoStatusList: [],
      loading: false,
      selected: {},
      selectAll: 0,
      pages: 0,
      pageSize: 10,
      erroMode: 0,
      workOrder: {},
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] && this.state.selected[original.id].checked === true}
                  onChange={() => this.toggleRow(original)}
                /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('work_order_no'),
          accessor: 'workOrderNo',
          width: 150,
          Cell: row => (
            this.linkToDetails(row)
          )
        }, {
          Header: couterpart.translate('shop_pcode'),
          accessor: 'fullPCode',
          filterable: false
        }, {
          Header: couterpart.translate('work_order_code'),
          accessor: 'sku',
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        }, {
          Header: couterpart.translate('work_order_urgent_level'),
          accessor: 'isUrgentByCustomer',
          width: 50,
          Cell: row => {
            row.styles['color'] = row.value === 1 ? 'red' : 'black';
            return row.value === 1 ? 'X' : '';
          },
          filterable: false,
          filterMethod: (filter, row) =>
            row[filter.id].includes(filter.value)
        }, {
          Header: 'MT',
          accessor: 'fimg',
          width: 100,
          sortable: false,
          Cell: row => (
            this.fImageRender(row)
          )
        }, {
          Header: 'MS',
          accessor: 'bimg',
          sortable: false,
          width: 200,
          Cell: row => (
            this.bImageRender(row)
          )
        }, {
          Header: couterpart.translate('work_order_color'),
          accessor: 'colorMaterial',
          filterable: false,
          width: 70
        }, {
          Header: couterpart.translate('work_order_size'),
          accessor: 'lengthSize',
          sortable: false,
          filterable: false,
          width: 100
        }, {
          Header: couterpart.translate('work_order_status'),
          accessor: 'status',
          width: 100,
          Cell: props => this.getStatusDescription(props.value)
        }, {
          Header: couterpart.translate('work_order_status_len'),
          accessor: 'lenStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getLenStatusDescription2(original)
        }, {
          Header: couterpart.translate('work_order_status_da'),
          accessor: 'daStatus',
          width: 100,
          Cell: ({ original }) => WorkOrderUtil.getDaStatusDescription2(original)
        }, {
          Header: couterpart.translate('order_date'),
          accessor: 'orderDate',
          sortable: false,
          filterable: false,
          width: 120
        }, {
          Header: couterpart.translate('work_order_prod_deadline'),
          accessor: 'prodDeadlineTs',
          filterable: false,
          width: 120
        }, {
          Header: couterpart.translate('work_order_worker'),
          accessor: 'workerFullName',
          filterable: false,
          width: 70
        }, {
          Header: couterpart.translate('work_order_itype'),
          accessor: 'itemType',
          width: 150,
          Cell: props => WorkOrderUtil.getItemTypeDescription(props.value)
        }],
      sortBy: 'PROD_DEADLINE',
      sortType: 'asc',
      ghiThiep: 0,
      workers: [],
      workerName: '',
      hoanthanh: 0
    };
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  fImageRender(row) {
    if (row.original.fimg === undefined || row.original.fimg === null) {
      return (<></>)
    }
    return (
      <img className="imageBox linkTo" alt="" width={100} height={70} src={`data:image/jpeg;base64,${row.original.fimg}`} name={'F' + row.original.workOrderNo} />
    )
  }

  bImageRender(row) {
    if (row.original.bimg === undefined || row.original.bimg === null) {
      return (<></>)
    }
    return (
      <img className="imageBox linkTo" alt="" width={100} height={70} src={`data:image/jpeg;base64,${row.original.bimg}`} name={'B' + row.original.workOrderNo} />
    )
  }

  toggleRow(row) {
    let newSelected = Object.assign({}, this.state.selected);
    if (newSelected[row.id] === undefined) {
      newSelected[row.id] = { checked: true, status: row.status, shipCode: row.shipCode };
    }

    if (this.state.selected[row.id]) {
      newSelected[row.id].checked = !this.state.selected[row.id].checked;
      newSelected[row.id].status = this.state.selected[row.id].status;
      newSelected[row.id].shipCode = this.state.selected[row.id].shipCode;
    }

    this.setState({
      selected: newSelected,
      selectAll: 2
    }, () => {
      WorkOrderUtil.saveItem('kcs.selected', JSON.stringify(this.state.selected));
    });
  }

  toggleSelectAll() {
    const newSelected = Object.assign({}, this.state.selected);
    if (this.state.selectAll === 0 || this.state.selectAll === undefined) {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: true, status: x.status, shipCode: x.shipCode };
        } else {
          newSelected[x.id].checked = true;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
        }
      });
    } else {
      this.state.workOrders.forEach(x => {
        if (newSelected[x.id] === undefined) {
          newSelected[x.id] = { checked: false, status: x.status, shipCode: x.shipCode };
        } else {
          newSelected[x.id].checked = false;
          newSelected[x.id].status = x.status;
          newSelected[x.id].shipCode = x.shipCode;
        }
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    }, () => {
      WorkOrderUtil.saveItem('kcs.selected', JSON.stringify(this.state.selected));
    });
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.workOrderNo}</label>
    )
  }

  handleEdit(row) {
    WorkOrderDataService.scanByNo(row.original.workOrderNo).then(data => {
      this.setState({
        show: true,
        workOrderId: data.id,
        workOrder: data
      });
    });
  }

  loadWorkers() {
    if (AuthenticationService.isKcs()) {
      UserDataService.retrieveWorkers().then(data => {
        let len = data.length;
        let workers = [];
        for (let i = 0; i < len; i++) {
          workers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
        }
        this.setState({ workers: workers });
      });
    }
  }

  componentDidMount() {
    this.loadWorkers();
    MasterDataService.retrieveAllStatus().then(data => {
      let statusList = [];

      if (data !== undefined && data !== null) {
        statusList.push({
          id: 0,
          name: 'All'
        });
        for (let i = 0; i < data.length; i++) {
          if (data[i].type !== 2) {
            continue;
          }

          if (data[i].status !== 41 && data[i].status !== 60) {
            continue;
          }
          statusList.push({
            id: data[i].status,
            name: data[i].statusDescVn
          });
        }
      }

      this.setState({ allStatus: data, statusList: statusList })
    });

    let fromDate = WorkOrderUtil.getItem("kcs.fromDate")
    let toDate = WorkOrderUtil.getItem("kcs.toDate")

    const values = undefined;
    let numOfMonths = 12;
    if (values !== undefined && values.status !== undefined) {
      numOfMonths = 24;
    }

    if (values === undefined || (values.status === undefined && values.isback === undefined)) {
      sessionStorage.removeItem('kcs.woStatus');
    }

    if (values === undefined || (values.status === undefined && values.isback === undefined) || fromDate === null || fromDate === undefined) {
      let backTime = 30 * 24 * 60 * 60 * 1000 * numOfMonths;
      fromDate = new Date(new Date().getTime() - backTime);//1 month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let status = WorkOrderUtil.getItem("kcs.status");
    let hoanthanh = WorkOrderUtil.getItem("kcs.hoanthanh");
    if (hoanthanh === undefined || hoanthanh === null) {
      hoanthanh = 0;
    }
    let swoStatusList = WorkOrderUtil.getItem('kcs.selectedWoStatusList');
    let woStatusList = [];
    try {
      woStatusList = JSON.parse(swoStatusList)
    } catch (ec) {

    }

    let page = 0;
    try {
      page = parseInt(WorkOrderUtil.getItem('kcs.page'));
      if (isNaN(page)) {
        page = 0;
      }
    } catch (ep) {
      page = 0;
    }

    let pageSize = 10;
    try {
      pageSize = parseInt(WorkOrderUtil.getItem('kcs.pageSize'));
      if (isNaN(pageSize)) {
        pageSize = 10;
      }
    } catch (eps) {
      pageSize = 10;
    }

    let sortBy = WorkOrderUtil.getItem('kcs.sortBy') ? WorkOrderUtil.getItem('kcs.sortBy') : 'PROD_DEADLINE';
    let sortType = WorkOrderUtil.getItem('kcs.sortBy') ? WorkOrderUtil.getItem('kcs.sortType') : 'asc';

    let sku = WorkOrderUtil.getItem('kcs.sku');
    let workerName = WorkOrderUtil.getItem('kcs.workerName');

    this.setState({
      fromDate: fromDate,
      toDate: toDate,
      status: status,
      orderNo: WorkOrderUtil.getItem("kcs.orderNo"),
      woStatus: WorkOrderUtil.getItem("kcs.woStatus"),
      selectedWoStatusList: woStatusList,
      page: page === undefined || page === null ? 0 : page,
      pageSize: pageSize === undefined || pageSize === null ? 10 : pageSize,
      sortBy: sortBy,
      sortType: sortType,
      sku: sku,
      workerName: workerName,
      hoanthanh: hoanthanh
    }, () => {
      this.fetchWorkOrdersBy();
    });

  }

  clearSearchInfo() {
    WorkOrderUtil.removeItem("kcs.fromDate")
    WorkOrderUtil.removeItem("kcs.toDate")
    WorkOrderUtil.removeItem("kcs.status")
    WorkOrderUtil.removeItem("kcs.orderNo")
    WorkOrderUtil.removeItem("kcs.woStatus")
    WorkOrderUtil.removeItem("kcs.pcode")
    WorkOrderUtil.removeItem('kcs.selectedPage')
    WorkOrderUtil.removeItem('kcs.selectedRow')
    WorkOrderUtil.removeItem("kcs.selectedWoStatusList");

    WorkOrderUtil.removeItem("kcs.page");
    WorkOrderUtil.removeItem("kcs.pageSize");
    WorkOrderUtil.removeItem("kcs.sortBy");
    WorkOrderUtil.removeItem("kcs.sortType");
    WorkOrderUtil.removeItem("kcs.sku");
    WorkOrderUtil.removeItem("kcs.workerName");
    WorkOrderUtil.removeItem("kcs.hoanthanh");
  }

  saveSearchInfo(fromDate, toDate, status, orderNo, woStatus, pcode,
    selectedWoStatusList, page, pageSize, sortBy, sortType, sku, workerName, hoanthanh) {
    WorkOrderUtil.saveItem("kcs.fromDate", fromDate);
    WorkOrderUtil.saveItem("kcs.toDate", toDate);
    WorkOrderUtil.saveItem("kcs.status", status);
    WorkOrderUtil.saveItem("kcs.orderNo", orderNo);
    WorkOrderUtil.saveItem("kcs.woStatus", woStatus);
    WorkOrderUtil.saveItem("kcs.pcode", pcode);
    WorkOrderUtil.saveItem("kcs.selectedWoStatusList", JSON.stringify(selectedWoStatusList));

    WorkOrderUtil.saveItem("kcs.page", page);
    WorkOrderUtil.saveItem("kcs.pageSize", pageSize);
    WorkOrderUtil.saveItem("kcs.sortBy", sortBy);
    WorkOrderUtil.saveItem("kcs.sortType", sortType);
    WorkOrderUtil.saveItem("kcs.sku", sku);
    WorkOrderUtil.saveItem("kcs.workerName", workerName);
    WorkOrderUtil.saveItem("kcs.hoanthanh", hoanthanh);
  }

  onFilter() {
    this.clearSearchInfo();
    this.setState({ page: 0, selected: {} });
    this.fetchWorkOrdersBy();
  }

  fetchWorkOrdersBy() {
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;

    let status = this.state.status;
    let woStatus = this.state.woStatus;
    let orderNo = this.state.orderNo;
    let pcode = this.state.pcode;
    let hoanthanh = this.state.hoanthanh;

    let selectedWoStatusList = this.state.selectedWoStatusList ? this.state.selectedWoStatusList : [WO_BONG, WO_HOANTHANH]
    let sortBy = this.state.sortBy;
    let sortType = this.state.sortType

    try {
      this.setState({ spinnerVisible: true, loading: true }, () => {
        this.setState({ workOrders: [] }, () => {

          if (status === undefined || status === null) {
            status = "all";
          }

          if (pcode === undefined || pcode === null) {
            pcode = "";
          }

          if (orderNo === undefined || orderNo === null) {
            orderNo = "";
          }

          let selectedWoStatusCodes = [];
          if (selectedWoStatusList) {
            for (let i = 0; i < selectedWoStatusList.length; i++) {
              selectedWoStatusCodes.push(selectedWoStatusList[i].id);
            }
          }

          if (selectedWoStatusCodes === undefined || selectedWoStatusCodes === null || selectedWoStatusCodes.length < 1){
            selectedWoStatusCodes = [WO_BONG, WO_HOANTHANH];
          }

          let page = 0;
          try {
            page = parseInt(WorkOrderUtil.getItem('kcs.page'));
            if (isNaN(page)) {
              page = 0;
            }
          } catch (ep) {
            page = 0;
          }

          let pageSize = 10;
          try {
            pageSize = parseInt(WorkOrderUtil.getItem('kcs.pageSize'));
            if (isNaN(pageSize)) {
              pageSize = 10;
            }
          } catch (eps) {
            pageSize = 10;
          }

          let sku = this.state.sku;

          let selected = this.state.selected;
          let workerName = this.state.workerName;

          let info = {
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            orderNo: orderNo,
            woStatus: undefined,
            isFull: 0,
            pcode: pcode,
            woStatusList: selectedWoStatusCodes,
            page: page === undefined ? 0 : page,
            pageSize: pageSize === undefined ? 10 : pageSize,
            sortBy: sortBy,
            sortType: sortType,
            sku: sku,
            workerName: workerName,
            hoanthanh: hoanthanh
          };

          WorkOrderDataService.finKcsWorkOrderList(info)
            .then(data => {
              if (data.message === undefined && data.data !== undefined && data.data instanceof Array) {
                this.setState({ workOrders: data.data, spinnerVisible: false, loading: false, pages: data.pages, page: page, pageSize: pageSize, selected: selected, selectAll: 0 },
                  () => {
                    this.saveSearchInfo(fromDate, toDate, status, orderNo, woStatus, pcode,
                      selectedWoStatusList, page, pageSize, sortBy,
                      sortType, sku, workerName, hoanthanh);
                  });
              } else {
                this.setState({ workOrders: [], loading: false, pages: 0, page: 0, pageSize: pageSize, selected: selected, selectAll: 0 });
                ToastsStore.error(data.message);
              }
            });
        });
      });
    } catch (e) {
      this.sleep(100).then(() => { this.setState({ spinnerVisible: false }); });
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  checkSelectedItems() {
    if ((this.state.selected === undefined) || (this.state.selected === null || this.state.selected.length < 1)) {
      return 1
    }
    let count = 0;
    for (let key in this.state.selected) {
      if (this.state.selected[key].checked === true) {
        let status = this.state.selected[key].status;
        let shipCode = this.state.selected[key].shipCode;
        if (status !== 45 || (status === 45 && shipCode !== undefined && shipCode !== null && shipCode.trim().length > 0)) {
          return 2;
        }
        count++;
      }
    }

    if (count < 1) {
      return 1;
    }
    return 0;
  }

  getStatusDescription(status) {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return status;
    }
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x => {
      return x.status === istatus;
    });
    if (statusInfo !== undefined) {
      return statusInfo.statusDescVn;
    }
    return status;
  }

  handleFromDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      fromDate: sDate
    });
  }

  handleToDateChange(date) {
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({
      toDate: sDate
    });
  }

  handleStatusChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      status: value
    });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.onFilter()
    }
  }

  handleOrderNoChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      orderNo: value
    });
  }

  handlePcodeChange(e) {
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }

    let value = e.target.value;
    this.setState({
      pcode: value
    });
  }

  renderStatusList() {
    if (this.state.allStatus === undefined || this.state.allStatus === null) {
      return (<></>);
    }

    return (
      <select onChange={this.handleStatusChange.bind(this)}
        value={this.state.status}>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        {this.state.allStatus.filter(y => {
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  handleSelectAllClick() {
    if (this.state.selectAll === '1') {
      this.setState({ selectAll: '0', selectedWoStatusList: [] });
    } else {
      let allStattus = this.state.statusList;
      this.setState({ selectAll: '1', selectedWoStatusList: allStattus });
    }
  }

  renderProductList() {
    return (
      <div className="row">
        <div className="col-12">
          <ReactTable
            manual
            NoDataComponent={() => null}
            previousText={"<"}
            nextText={">"}
            page={this.state.page}
            pages={this.state.pages}
            onPageChange={pageIndex => {
              WorkOrderUtil.saveItem('kcs.page', pageIndex);
              this.fetchWorkOrdersBy()
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              WorkOrderUtil.saveItem('kcs.page', pageIndex);
              WorkOrderUtil.saveItem('kcs.pageSize', pageSize);
              this.fetchWorkOrdersBy()
            }}
            onSortedChange={sorted => {
              console.log(sorted)
              let sortType = this.state.sortType === 'desc' ? 'asc' : 'desc';
              this.setState({
                sortBy: sorted[0].id,
                sortType: sortType
              }, () => {
                this.fetchWorkOrdersBy()
              });
            }}
            data={this.state.workOrders}
            loading={this.state.loading}
            columns={this.state.columns}
            defaultPageSize={10}
            showPageSizeOptions={true}
            pageSizeOptions={[3, 5, 10, 20]}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: (e) => {
                    this.setState({
                      selectedRow: rowInfo.index,
                      workOrderId: rowInfo.original.id
                    }, () => {
                      WorkOrderUtil.saveItem('kcs.selectedRow', this.state.selectedRow);
                    })
                  },
                  style: {
                    background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                    color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
                  }
                }
              } else {
                return {}
              }
            }}
          />
        </div>
      </div>
    )
  }

  onSelect(selectedList, selectedItem) {
    this.setState({
      selectedCountries: selectedList
    });
  }

  onRemove(selectedList, removedItem) {
    this.setState({
      selectedCountries: selectedList
    });
  }

  onStatusSelect(selectedList, selectedItem) {
    if (selectedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  onStatusRemove(selectedList, removedItem) {
    if (removedItem.id === 0) {
      this.handleSelectAllClick()
      return;
    }
    this.setState({
      selectedWoStatusList: selectedList
    });
  }

  handleSkuChange(e) {
    var value = e.target.value;
    this.setState(prevState => ({
      sku: value
    }));
  }

  handleClose() {
    this.setState({ show: false });
  }

  renderColor() {
    if (this.state.workOrder.colorMaterial === undefined || this.state.workOrder.colorMaterial === null) {
      return (
        <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.colorMaterial}</label></div>
      );
    }
    if ((this.state.workOrder.colorMaterial.toUpperCase() === 'VÀNG') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU VÀNG')) {
      return (
        <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor: 'yellow' }}><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.colorMaterial}</label></div>
      );
    }

    if ((this.state.workOrder.colorMaterial.toUpperCase() === 'HỒNG') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU HỒNG')) {
      return (
        <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor: 'pink' }}><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.colorMaterial}</label></div>
      );
    }

    if ((this.state.workOrder.colorMaterial.toUpperCase() === 'BẠC') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU BẠC')) {
      return (
        <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor: 'grey' }}><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.colorMaterial}</label></div>
      );
    }

    return (
      <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.colorMaterial}</label></div>
    );
  }

  getCurrentStatus(status) {
    if (this.state.allStatus === undefined || this.state.allStatus.length < 1) {
      return status;
    }

    let currentStatus = this.state.allStatus.find(x => {
      return x.status === status;
    });
    return currentStatus ? currentStatus.statusDescVn : status;
  }

  changeWorkOrderToHoanThanh() {
    if (this.state.workOrder.status != WO_BONG) {
      alert(couterpart.translate('work_order_invalid_status'));
      return;
    }

    let wo = JSON.parse(JSON.stringify(this.state.workOrder))
    wo.status = WO_HOANTHANH;
    wo.eventName = AuthenticationService.getRole() + "_" + EVENT_NAME_CHANGE_WO_STATUS;
    this.setState({
      workOrder: wo,
      inputOrderNo: ''
    }, () => {
      WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
        if (data.updated === 0) {
          this.setState({
            workOrder: {},
            inputOrderNo: ''
          });
        }
        this.handleClose();
        this.fetchWorkOrdersBy();
      });
    });
  }

  renderWorkerByRole() {
    return (<label>{this.state.workOrder.workerFullName}</label>);
  }

  renderFilterWorkerOption(option) {
    return (
      <option key={option.key} value={option.userName}>{option.userName}</option>
    );
  }

  renderFilterWorkers() {
    if ((this.state.workers === undefined)) {
      return (<></>);
    }
    return (
      <>
        <select onChange={this.handleWorkerFilterChange.bind(this)} className="select_margin" style={{ width: "100%", height: "50%" }}>
          <option key="" value=""></option>
          {this.state.workers !== undefined && this.state.workers.map(option => this.renderFilterWorkerOption(option))}
        </select>&nbsp;&nbsp;
      </>
    );
  }

  handleWorkerFilterChange(e) {
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      workerName: value
    });
  };

  renderDetails() {
    if (this.state.workOrder.workOrderNo === undefined) {
      return (<div>&nbsp;
      </div>)
    }

    return (
      <div>
        <div className="row">
          <div className="col-8">
            <div className="row">
              <div className="col-4 border-top border-left border-light-gray">
                <div className="row"><img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode} /></div>
                <div className="row">
                  <label className="label_link"> {this.state.workOrder.workOrderNo} </label>
                </div>
              </div>
              <div className="col-8 border-top border-left border-light-gray">
                <div className="row border-bottom border-light-gray">
                  <div className="col"><b>{couterpart.translate('work_order_order_date_s')}</b></div>
                  <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}</div>
                </div>
                <div className="row border-bottom border-light-gray">
                  <div className="col"><b>{couterpart.translate('work_order_leadTimeProduction')}</b></div>
                  <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.leadTimeProduction)}</div>
                </div>
                <div className="row border-bottom border-light-gray">
                  <div className="col"><b>{couterpart.translate('work_order_worker')}</b></div>
                  <div className="col border-left border-right border-light-gray">{this.renderWorkerByRole()}</div>
                </div>
                <div className="row border-bottom border-light-gray">
                  <div className="col"><b>{couterpart.translate('work_order_end_date')}</b></div>
                  <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs)}</div>
                </div>
                <div className="row border-bottom border-light-gray">
                  <div className="col">
                    <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
                  </div>
                  <div className="col border-left border-right border-light-gray">
                    <label className="labelValueBox">{
                      WorkOrderUtil.formatShortDisplayDateMMddyyyy3(this.state.workOrder.ngayNhapLieu)
                    }</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_code')}</b></div>
              <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.sku}</div>
              <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('shop_pcode')}</b></div>
              <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.fullPCode}</div>
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_color')}</b></div>
              {
                this.renderColor()
              }
            </div>
            <div className="row">
              <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_type')}</b></div>
              <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.shapeDesign}</div>
              <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_quantity_s')}</b></div>
              <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.qty}</div>
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_size')}</b></div>
              <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px' }}>{this.state.workOrder.lengthSize}</label></div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_font')}</b></div>
              <div className="col-5 border-top border-left border-light-gray"><pre>{this.state.workOrder.font}</pre></div>
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_personalization')}</b></div>
              <div className="col-3 border-top border-left border-right border-light-gray"><pre style={{ 'fontSize': '20px' }}>{this.state.workOrder.personalization}</pre></div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_urgent_level')}</b></div>
              <div className="col-10 border-top border-left border-right border-light-gray">
                <label style={{ 'fontSize': '20px', color: 'red', margin: '2px' }}>{this.state.workOrder.isUrgentByCustomer === 1 ? 'X' : ''}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_special_note')}</b></div>
              <div className="col-10 border-top border-left border-right border-light-gray">{this.state.workOrder.notesInternal}</div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_status')}</b></div>
              <div className="col-2 border-top border-left border-right border-light-gray">{this.getCurrentStatus(this.state.workOrder.status)}</div>
              <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_shipping_note')}</b></div>
              <div className="col-6 border-top border-left border-right border-light-gray">{this.state.workOrder.shippingNote}</div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                <label className="labelBox">{couterpart.translate('work_order_itype')}</label>
              </div>
              <div className="col-10 border-top border-left border-right border-light-gray">
                {WorkOrderUtil.getItemTypeDescription(this.state.workOrder.itemType)}
              </div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                <label className="labelBox">
                  {couterpart.translate('work_order_status_len')}
                </label>
              </div>
              <div className="col-10 border-top border-left border-right border-light-gray">
                {WorkOrderUtil.getLenStatusDescription2(this.state.workOrder)}
              </div>
            </div>
            <div className="row">
              <div className="col-2 border-top border-left border-light-gray">
                <label className="labelBox">
                  {couterpart.translate('work_order_status_da')}
                </label>
              </div>
              <div className="col-10 border-top border-left border-right border-light-gray">
                {WorkOrderUtil.getDaStatusDescription2(this.state.workOrder)}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <button className="myBigButton" onClick={this.changeWorkOrderToHoanThanh.bind(this)}>
                  <FaEdit color={ICON_COLOR} />
                  &nbsp;{couterpart.translate('button_ht')}</button>
              </div>
            </div>
          </div>
          <div className="col-4">
            <WorkOrderImages mode="MODE_EDIT" workOrderId={this.state.workOrderId} largeMode={1}
              isUpdated={this.state.updated} />
            <div className="row">&nbsp;</div>
          </div>
        </div>
      </div>
    )
  }

  handleHoanthanhFlterClick(e) {
    let value = e.target.value;
    this.setState({ hoanthanh: value });
  }

  renderHoanthanhFilter() {
    return (
      <>
        <div className="col-1">&nbsp;</div>
        <div className="col-4">
          <input type="radio" value="1" onChange={this.handleHoanthanhFlterClick.bind(this)} checked={this.state.hoanthanh == 1 ? true : false} /> { "Bóng cần làm dây" }<br/>
        </div>
        <div className="col-3">
          <input type="radio" value="2" onChange={this.handleHoanthanhFlterClick.bind(this)} checked={this.state.hoanthanh == 2 ? true : false} /> { "Bóng khác" }<br/>
        </div>
        <div className="col-4">
          <input type="radio" value="0" onChange={this.handleHoanthanhFlterClick.bind(this)} checked={this.state.hoanthanh == 0 ? true : false} /> { "Tất cả" }
        </div>
      </>
    );
  }

  render() {
    if (!AuthenticationService.isKcs()) {
      return (<div>Unauthorized access.</div>);
    }

    return (
      <div>
        <MenuComponent2 />
        <ToastsContainer store={ToastsStore} position="bottom_center" />
        <br />
        <div className="row">
          <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
            <div className="row">
              <div className="col-2">
                <label><b>{couterpart.translate('order_date_from')}</b></label>
              </div>
              <div className="col-3">
                <div className="customDatePickerWidth">
                  <DatePicker name="orderDateFrom"
                    dateFormat="MM/dd/yyyy hh:mm"
                    selected={WorkOrderUtil.convertToDate(this.state.fromDate)}
                    onChange={this.handleFromDateChange.bind(this)} />
                </div>
              </div>
              <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label></div>
              <div className="col-3">
                <div className="customDatePickerWidth">
                  <DatePicker name="orderDateTo"
                    dateFormat="MM/dd/yyyy hh:mm"
                    selected={WorkOrderUtil.convertToDate(this.state.toDate)}
                    onChange={this.handleToDateChange.bind(this)} />
                </div>
              </div>
            </div>
            <div className='row'> <div className="col-12">&nbsp;</div></div>
            <div className='row'>
              { this.renderHoanthanhFilter() }
            </div>
          </div>
          <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px' }}>
            <div className="row">
              <div className="col-12">
                <label><b>{couterpart.translate('work_orders')}</b></label>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Multiselect style={{ width: "100%" }}
                  options={this.state.statusList}
                  selectedValues={this.state.selectedWoStatusList}
                  onSelect={this.onStatusSelect.bind(this)}
                  onRemove={this.onStatusRemove.bind(this)}
                  displayValue="name"
                  showCheckbox={true}
                />
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="row">
              <div className="col-8">
                <div className="row">
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.orderNo} style={{ width: "100%" }} id="orderNo"
                      placeholder={couterpart.translate('order_no')}
                      onChange={this.handleOrderNoChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }} />
                  </div>
                  <div className="col-6">
                    <input type="text" defaultValue={this.state.pcode} style={{ width: "100%", marginBottom: '5px' }} id="pcode"
                      placeholder={couterpart.translate('shop_pcode')}
                      onChange={this.handlePcodeChange.bind(this)} onKeyDown={(e) => { e.persist(); setTimeout(() => { this.handlePcodeChange(e) }, 0); }} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    { this.renderFilterWorkers() }
                  </div>
                </div>
              </div>
              <div className="col-2">
                <button className="myButton" onClick={this.onFilter.bind(this)} style={{ width: "90%" }}><FaFilter color={ICON_COLOR} />{couterpart.translate('button_filter')}</button>
              </div>
            </div>
          </div>
        </div>
        {this.renderProductList()}
        <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static" dialogClassName="modal-90w">
          <Modal.Header closeButton>
            <Modal.Title>Hoàn Thành</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderDetails()}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
          </Modal.Footer>
        </Modal>
        <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
        <Dialog ref={(component) => { this.dialog = component }} />
      </div>
    )
  }
}
export default withRouter(KcsProductList);